module.exports = __webpack_public_path__ + "img/slider_partikel_en.8f9b9512.png";